import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import it from './it.json';
// import ru from './ru.json';

const saved = localStorage.getItem('lang');

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    it: { translation: it },
    // ru: { translation: ru },
  },
  lng: saved || 'en',
  fallbackLng: 'en',
  returnNull: false,
  returnEmptyString: false,
  interpolation: { escapeValue: false },
});

export default i18n;
